// Player/Renderer: MUI styled → inline styles.

import type { RefObject } from "react";

interface Props {
    readonly canvasContainerRef: RefObject<HTMLDivElement | null>;
    readonly htmlContainerRef: RefObject<HTMLDivElement | null>;
}

const fullSize: React.CSSProperties = {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
};

// NOTE: Credits are NOT rendered inside Renderer any more. They used to
// live inside this sticky-contained WebGL box, but that put them inside
// the sticky's z-index:998 stacking context, which meant they could
// never sit above NavigationControls (which is fixed bottom-0 z-[1101]
// at a higher DOM level). Stacking contexts nest: our inner z-index
// never escapes its parent context, so 998's stacking was globally
// stuck behind 1101, and the Unsplash link clicks always landed on the
// nav-controls hit-box instead of the <a> tags.
//
// Credits are now rendered by VisualStoryPlayer as a sibling of the
// sticky container — same DOM level as NavigationControls — with
// z-index high enough to sit on top of them.
export default function Renderer({ canvasContainerRef, htmlContainerRef }: Props) {
    return (
        <div>
            <div ref={canvasContainerRef} style={fullSize} />
            <div ref={htmlContainerRef} style={fullSize} />
        </div>
    );
}
